// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-1-5[data-v-1e50609e]{margin-top:6px}", ""]);
// Exports
module.exports = exports;
